import hljs from 'lib/utils/hljsConfig'

Array
  .from(document.querySelectorAll('pre code:not(.hljs)'))
  .forEach(el => hljs.highlightElement(el))
